function MapWidget() {
  return (
    <iframe
      className="position-relative rounded w-100 h-100"
      src={process.env.REACT_APP_JOB_PORTAL_MAP_URL}
      frameBorder="0"
      style={style.map}
      allowFullScreen=""
      aria-hidden="false"
      tabIndex="0"
      title="gmaps"
    ></iframe>
  );
}

const style = {
  map: { minHeight: "400px", border: 0 },
};
export default MapWidget;
